import { render, staticRenderFns } from "./require-toon-wrapper.vue?vue&type=template&id=1059f85c&lang=pug&"
import script from "./require-toon-wrapper.vue?vue&type=script&lang=js&"
export * from "./require-toon-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports